import { useRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import { InvalidTokenRetryFallback } from './fallback'

const MAX_INVALID_TOKEN_RETRIES = 2
const RETRY_DELAY = 1000

/** Should be used on client authenticated pages.
 * Checks for 'invalid token' errors and retries the request.
 */
export const ClientErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const invalidTokenRetryCountRef = useRef(0)

  const incrementInvalidTokenRetryCount = () => {
    invalidTokenRetryCountRef.current += 1
  }

  return (
    <ErrorBoundary
      fallbackRender={(props) => (
        <InvalidTokenRetryFallback
          {...props}
          retryCount={invalidTokenRetryCountRef.current}
          maxRetries={MAX_INVALID_TOKEN_RETRIES}
          onRetryAttempt={incrementInvalidTokenRetryCount}
          retryDelay={RETRY_DELAY}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  )
}
